import { useState, useEffect } from "react";
import axios from "../services/axios";

export default function useAvatares(source) {
  const [images, setImages] = useState([]);

  useEffect(() => {
    axios.get("images/getImages").then((res) => {
      const { data } = res;
      let result = {};

      data.forEach((url) => {
        const isAvatar = url.includes("/avatar/");
        const filename = url.split("/").pop(); // pega só o nome do arquivo
        const name = isAvatar
          ? filename.replace("avatar_", "").replace(".png", "")
          : filename.replace(".png", "");

        if (!result[name]) {
          result[name] = {};
        }

        if (isAvatar) {
          result[name].avatar = url;
        } else {
          result[name].complete = url;
        }
      });

      setImages(result);
    });
  }, []);

  return { images };
}
